function convertToCurrency(amount) {
    return Shopify?.currency?.rate ? Math.trunc(Shopify.currency.rate * Number(amount)) : Math.trunc(Number(amount))
}

const fetchCart = async () => {
    try {
      const res = await fetch('/cart.js');
      const data = await res.json();
      if (res.ok) return data;
    } catch (error) {
      console.log(error);
      return null
    }
}

const init = e => {
    const debounce = (f, delay) => {
        let timer = 0;
        return function(...args) {
            clearTimeout(timer);
            timer = setTimeout(() => f.apply(this, args), delay);
        }
    }

    const sliderReinitCallback = ([entry]) => {
        const flkty = Flickity.data(entry.target);
        if (flkty) {
            flkty.resize()

            // remove in-slider view all slide on desktop
            // if (window.innerWidth >= 768) {
            //     let view_all_slide = entry.target.querySelector('.collection-slider__view-all');
            //     if (view_all_slide) {
            //         flkty.remove(view_all_slide);
            //     }
            // }
        };
    }

    const activateSlider = (elem) => {
        const defaultSettings = {
            prevNextButtons: false,
            cellAlign: "left",
            groupCells: true
        }
        const { sliderSettings: customSettings } = elem.dataset;
        let flkty;
        if (customSettings)
            Object.assign(defaultSettings, JSON.parse(customSettings));

        flkty = new Flickity(elem, defaultSettings);

        const reinitFlickitySlider = new ResizeObserver(debounce(sliderReinitCallback, 200));
        reinitFlickitySlider.observe(elem);
    }

    const mediaQueryActivateSlider = (elem, query) => {
        const mediaQueryList = window.matchMedia(query);
        const defaultSettings = {
          prevNextButtons: false,
          cellAlign: "left",
          groupCells: true
        }
        const { sliderSettings: customSettings } = elem.dataset;
        let flkty;
      
        if (customSettings)
          Object.assign(defaultSettings, JSON.parse(customSettings));
      
        if (mediaQueryList.matches)
          flkty = new Flickity(elem, defaultSettings);
      
        mediaQueryList.addEventListener('change', (event) => {
          if (event.matches) {
            flkty = new Flickity(elem, defaultSettings)
          } else {
            flkty.destroy();
          }
        });
      
        const reinitFlickitySlider = new ResizeObserver(debounce(sliderReinitCallback, 200));
        reinitFlickitySlider.observe(elem);
    }

    const sliders = document.querySelectorAll('.slider-enabled');
    if(sliders.length) {
        sliders.forEach(slider => {
            activateSlider(slider);
        })
    }

    document.addEventListener('customInitSlider', (e) => {
        activateSlider(e.detail.slider)
    })

    const addProductById = async (id, properties = {}) => {
        let formData = {
            'items': [{
                'id': id,
                'quantity': 1,
                'properties': properties
            }]
        };
        fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
        })
        .then(async response => {
            document.dispatchEvent(new CustomEvent('cart:build'));
            document.dispatchEvent(new CustomEvent('cart:open'));
            const data = await response.json();

            try {
                $g.track({
                    scope: "basket",
                    action: "add",
                    data: { product_id: data.items[0].product_id , quantity: data.items[0].quantity },
                    successs:function(response){
                        console.log("adding",response)
                    }
                });
            } catch (err) {
                console.log({err})
            }

            return data;
        })
        .catch((error) => {
            console.error('Error:', error);
        });
    }

    // START PDP MODEL ALSO WEARING
    // Update variant
    $(document).on('change', '.model-also-wearing__item-select', (e) => {
        const select = e.currentTarget;
        const selectedPrice = select.options[select.selectedIndex].getAttribute('data-price');
        const selectedCompareAtPrice = select.options[select.selectedIndex].getAttribute('data-compare-at-price');
        const parent = select.closest('.model-also-wearing__item');
        const price_wrapper = parent.querySelector('.model-also-wearing__item-price');

        let priceHTML = '';
        
        if (selectedCompareAtPrice != '' && parseInt(selectedCompareAtPrice) > parseInt(selectedPrice)) {
            priceHTML += `
                <span class="text-red">${theme.Currency.formatMoney(selectedPrice, theme.settings.moneyFormat)}</span>
                <span class="grid-product__price--original">${theme.Currency.formatMoney(selectedCompareAtPrice, theme.settings.moneyFormat)}</span>
            `;
        } else {
            priceHTML += `
                <span>${theme.Currency.formatMoney(selectedPrice, theme.settings.moneyFormat)}</span>
            `;
        }

        price_wrapper.innerHTML = priceHTML;
    })

    // Add MAW to cart
    $(document).on('click', '.pdp-maw__atc-btn', (e) => {
        const btn = e.currentTarget;
        const ignoreGWP = btn.hasAttribute('data-ignore-gwp');
        const parent = btn.closest('.model-also-wearing__item');
        const select = parent.querySelector('.model-also-wearing__item-select');
        const selected = select.options[select.selectedIndex].value;

        if (!selected || selected == '') return;

        if (ignoreGWP) {
            addProductById(selected, {"_ignore-gwp": true})
        } else {
            addProductById(selected)
        }
        
    })
    // END PDP MODEL ALSO WEARING

    document.addEventListener('recommendations:loaded', function() {
        const sliders = document.querySelectorAll('.recommendations-slider');
        if(sliders.length) {
            sliders.forEach(slider => {
                activateSlider(slider);
            });
        }

        const completeTheLookSelect = document.querySelectorAll('.js-complementary-slider__update-variant');
        if(completeTheLookSelect.length) {
            completeTheLookSelect.forEach(sel => {
                const parent = sel.closest('.complementary-product');
                const addToCartBtn = parent.querySelector('.js-complementary-slider__add-to-cart');
                sel.addEventListener('change', function(e) {
                    const variantId = e.target.value;
                    addToCartBtn.setAttribute('data-id', variantId);
                });
            })
        }

        const completeTheLookATCBtn = document.querySelectorAll('.js-complementary-slider__add-to-cart');
        if(completeTheLookATCBtn.length) {
            completeTheLookATCBtn.forEach(btn => {
                btn.addEventListener('click', function(e) {
                    const id = e.target.getAttribute('data-id');
                    const ignoreGWP = e.target.hasAttribute('data-ignore-gwp');

                    if (ignoreGWP) {
                        addProductById(id, {"_ignore-gwp": true});
                    } else {
                        addProductById(id);
                    }
                });
            })
        }
    });

    // CART UPSELL
    $(document).on('change', 'select.js-cart-upsell-slider__add-to-cart', (e) => {
        if(e.target.hasAttribute('data-freegift')) {
            addFreeGiftToCart(e);
        } else {
            addUpsellToCart(e);
        }
    })

    $(document).on('click', '.cart-upsell-slider__add-to-cart', (e) => {
        e.preventDefault();
        if (e.currentTarget.hasAttribute('disabled')) {
            return;
        }
        if(e.target.hasAttribute('data-freegift')) {
            addFreeGiftToCart(e);
        } else {
            addUpsellToCart(e);
        }
    })

    const addUpsellToCart = (e) => {
        let id;
        let parent = e.target.closest('.cart-upsell-slider__slide');
        if(e.type === "click") {
            id = e.target.getAttribute('data-id');
        } else if(e.type === "change") {
            id = e.target.value;
        } else {
            return;
        }

        let properties = {};
        if (parent.hasAttribute('data-ignore-gwp')) {
            properties["_ignore-gwp"] = true;
        }
        
        let formData = {
            'items': [{
                'id': id,
                'quantity': 1,
                'properties': properties
            }]
        };
        fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
        })
        .then(async response => {
            document.dispatchEvent(new CustomEvent('cart:build'));
            parent.classList.add('hide');

            const data = await response.json();

            try {
                $g.track({
                    scope: "basket",
                    action: "add",
                    data: { product_id: data.items[0].product_id , quantity: data.items[0].quantity },
                    successs:function(response){
                        console.log("adding",response)
                    }
                });
            } catch (err) {
                console.log({err})
            }

            return data;
        })
        .catch((error) => {
            console.error('Error:', error);
        });
    }

    const addFreeGiftToCart = (e) => {
        let id;
        let parent = e.target.closest('.free-gift-with-purchase-slider');
        let promoTier = parent.getAttribute('data-promotion-tier');
        if(promoTier) {
            if(e.type === "click") {
                id = e.target.getAttribute('data-id');
            } else if(e.type === "change") {
                id = e.target.value;
            } else {
                return;
            }
            
            let formData = {
                'items': [{
                    'id': id,
                    'quantity': 1,
                    'properties': {
                        "_promotion_tier": promoTier
                    }   
                }]
            };
            fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
            })
            .then(async response => {
                document.dispatchEvent(new CustomEvent('cart:build'));
                parent.classList.add('hide');
                const data = await response.json();

                // try {
                //     $g.track({
                //         scope: "basket",
                //         action: "add",
                //         data: { product_id: data.items[0].product_id , quantity: 1 },
                //         successs:function(response){
                //             console.log("adding",response)
                //         }
                //     });
                // } catch (err) {
                //     console.log({err})
                // }

                return data;
            })
            .catch((error) => {
                console.error('Error:', error);
            });
        }
    }

    let removing_gift = false;
    const removeFreeGiftFromCart = async () => {
        if (removing_gift) return;
        removing_gift = true;

        // If only allowing gift from highest available tier
        let highest_only = false;
        const tierSliders = document.querySelectorAll('.free-gift-with-purchase-slider[data-promotion-tier]');
        tierSliders.forEach(tier => {
            if (tier.hasAttribute('data-highest')) {
                highest_only = true;
            }
        })

        let giftsToRemove = [];

        const cartData = await fetchCart();

        let t1_key = null;
        let t2_key = null;
        let t3_key = null;

        cartData.items.forEach(item => {
            if (item.properties?.["_promotion_tier"]) {
                if (item.final_price > 0) {
                    giftsToRemove.push(item.key);
                }
                if (highest_only) {
                    if ( item.properties["_promotion_tier"] == "1") {
                        t1_key = item.key;
                    } else if ( item.properties["_promotion_tier"] == "2") {
                        t2_key = item.key;
                    } else if ( item.properties["_promotion_tier"] == "3") {
                        t3_key = item.key;
                    }
                }
            }
            if (item.properties?.["_gwp-gift"] && item.final_price > 0) {
                giftsToRemove.push(item.key);
            }
        })

        if (highest_only) {
            cartData.items.forEach(item => {
                if (item.properties?.["_promotion_tier"] == "2" && t1_key) {
                    if (!giftsToRemove.includes(t1_key)) {
                        giftsToRemove.push(t1_key);
                    }
                }
                if (item.properties?.["_promotion_tier"] == "3" && t1_key) {
                    if (!giftsToRemove.includes(t1_key)) {
                        giftsToRemove.push(t1_key);
                    }
                }
                if (item.properties?.["_promotion_tier"] == "3" && t2_key) {
                    if (!giftsToRemove.includes(t2_key)) {
                        giftsToRemove.push(t2_key);
                    }
                }
            })
        }

        if (giftsToRemove.length < 1) {
            removing_gift = false;
            return;
        };

        let updates = {};

        giftsToRemove.forEach(key => {
            updates[`${key}`] = 0
        })

        jQuery.post(window.Shopify.routes.root + 'cart/update.js', {
            updates: updates
        }).then(
            setTimeout(() => {
                document.dispatchEvent(new CustomEvent('cart:build'))
            }, 500)
        );

        removing_gift = false;
    }

    // CART GWP
    $(document).on('click', '.gwp-item__atc', (e) => {
        const btn = e.currentTarget;
        const parent = btn.closest('.gwp-item');

        const gift_handle = parent.getAttribute('data-gift-handle');
        if (!gift_handle || gift_handle == '') return;

        const parent_for_key = parent.getAttribute('data-for-key');
        if (!parent_for_key || parent_for_key == '') return;

        const parent_for_title = parent.getAttribute('data-for-title');
        if (!parent_for_title || parent_for_title == '') return;

        const select = parent.querySelector('.gwp-item__select');
        if (!select) return;

        const gift_id = select.options[select.selectedIndex].value;
        if (!gift_id || gift_id == '') return;

        // Add gift
        let formData = {
            'items': [{
                'id': gift_id,
                'quantity': 1,
                'properties': {
                    '_gwp-gift': "true",
                    '_gwp-gift-handle': gift_handle,
                    '_gwp-parent': parent_for_key,
                    '_gwp-parent-title': parent_for_title
                }
            }]
        };
        fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
        })
        .then(async response => {
            document.dispatchEvent(new CustomEvent('cart:build'));
            parent.classList.add('hide');
            document.dispatchEvent(new CustomEvent('cart:open'));
            const data = await response.json();

            // try {
            //     $g.track({
            //         scope: "basket",
            //         action: "add",
            //         data: { product_id: data.items[0].product_id , quantity: 1 },
            //         successs:function(response){
            //             console.log("adding",response)
            //         }
            //     });
            // } catch (err) {
            //     console.log({err})
            // }

            return data;
        })
        .catch((error) => {
            console.error('Error:', error);
        });
    });

    // CART EVENTS
    ['cart:ready', 'cart:updated'].forEach(evt => {
        document.addEventListener(evt, () => {
            removeFreeGiftFromCart();

            const cartUpsellSliders = document.querySelectorAll('.cart-upsell-slider__slider');
            if(cartUpsellSliders.length) {

                // Activate upsell sliders
                cartUpsellSliders.forEach(cartUpsellSlider => {
                    const cartSlides = cartUpsellSlider.querySelectorAll('.slide-item');
                    if(cartSlides.length) {
                        activateSlider(cartUpsellSlider);
                    } else {
                        cartUpsellSlider.closest('.cart-upsell-slider').classList.add('hide');
                    }
                });
            }

            const showHideTierPromotions = async () => {
                const tierSliders = document.querySelectorAll('.free-gift-with-purchase-slider');
                const cartData = await fetchCart();
                const cartTotal = cartData.total_price;

                // If only allowing gift from highest available tier
                let highest_only = false;
                let t1_in_cart = false;
                let t2_in_cart = false;
                let t3_in_cart = false;
                
                let cartSubTotal = 0;
                cartData.items.forEach(item => {
                    if (!item.properties?.["_ignore-gwp"]) {
                        cartSubTotal += item.final_line_price;
                    }
                })
    
                if(tierSliders.length) {
                    let cart_tier_promotion_tracker = [];
                    for (let i=0;i<theme.promotions.length;i++) {
                        cart_tier_promotion_tracker.push(false);
                    }
                    cartData.items.forEach(item => {
                        if(item.properties) {
                            if(item.properties['_promotion_tier']) {
                                cart_tier_promotion_tracker[item.properties['_promotion_tier'] - 1] = true;

                                if (item.properties['_promotion_tier'] == '1') {
                                    t1_in_cart = true;
                                }
                                if (item.properties['_promotion_tier'] == '2') {
                                    t2_in_cart = true;
                                }
                                if (item.properties['_promotion_tier'] == '3') {
                                    t3_in_cart = true;
                                }
                            }
                        }
                    });
                    tierSliders.forEach(tier => {
                        tier.classList.add('hide');
                        if (tier.hasAttribute('data-highest')) {
                            highest_only = true;
                        }
                    })
                    for (let i=0;i<theme.promotions.length;i++) {
                        let tier_level = i+1;
                        if ((cartSubTotal/100) >= convertToCurrency(theme.promotions[i].price) && !cart_tier_promotion_tracker[i]) {
                            const promoSlider = document.querySelector('.free-gift-with-purchase-slider[data-promotion-tier="'+tier_level+'"]');
                            const cartSlides = promoSlider.querySelectorAll('.slide-item');
                            if(cartSlides.length) {
                                if (highest_only) {
                                    // hide all sliders
                                    tierSliders.forEach(tier => {
                                        tier.classList.add('hide');
                                    })

                                    if (tier_level < 2) {
                                        if (t2_in_cart || t3_in_cart) {
                                            promoSlider.classList.add('hide');
                                        } else {
                                            promoSlider.classList.remove('hide');
                                        }
                                    } else if (tier_level < 3) {
                                        if (t3_in_cart) {
                                            promoSlider.classList.add('hide');
                                        } else {
                                            promoSlider.classList.remove('hide');
                                        }
                                    } else {
                                        promoSlider.classList.remove('hide');
                                    }
                                } else {
                                    promoSlider.classList.remove('hide');
                                }
                            } else {
                                promoSlider.classList.add('hide');
                            }
                        }
                    }
                }
            }
            
            const tierPromotionsEnabled = theme.settings.enableTierPromotions;
            
            if(tierPromotionsEnabled) {
                showHideTierPromotions();
            }
        });


        // Mobile Panel
        $(document).on('click', '.mobile-cart-upsell-panel__quick-add-btn', async (e) => {
            const btn = e.currentTarget;
            const parent = btn.closest('.grid-product__quick-add');
            const select = parent.querySelector('select');
            const selected_var = select.options[select.selectedIndex].value;
            if (!selected_var) return;

            btn.innerHTML = "Adding...";

            const res = await addProductById(selected_var);
            // console.log({res})

            // close drawer
            setTimeout(() => {
                const panel = document.querySelector('.mobile-cart-upsell-panel__outer');
                if (panel) {
                    panel.classList.remove('active');
                }
            }, 400);
        })

        $(document).on('click', '.mobile-cart-upsell-panel__quick-add-btn--single', async (e) => {
            const btn = e.currentTarget;
            const selected_var = btn.getAttribute('data-id');
            if (!selected_var) return;

            btn.innerHTML = "Adding...";

            const res = await addProductById(selected_var);
            // console.log({res})

            // close drawer
            setTimeout(() => {
                const panel = document.querySelector('.mobile-cart-upsell-panel__outer');
                if (panel) {
                    panel.classList.remove('active');
                }
            }, 400);
        })

        document.addEventListener('drawerOpen.CartDrawer', () => {
            const panel = document.querySelector('.mobile-cart-upsell-panel__outer');
            if (panel) {
                panel.classList.add('active');
            }
        })
    });

    // Enable disclosure selector functionality on mobile menu
    const currencyEl = document.querySelectorAll('.multi-selectors-wrapper [data-disclosure-currency]');
    const localeEl = document.querySelectorAll('.multi-selectors-wrapper [data-disclosure-locale]');

    if(currencyEl.length) {
        currencyEl.forEach(el => {
            new theme.Disclosure(el);
        });
    }

    if(localeEl.length) {
        localeEl.forEach(el => {
            new theme.Disclosure(el);
        });
    }

    // Tabbed collections show/hide
    const tabbedCollectionLink = document.querySelectorAll('.tabbed-collections__link');
    if(tabbedCollectionLink.length) {
        const activeSlider = document.querySelector('.tabbed-collections__tabbed-content.active .product-grid-featured');
        activateSlider(activeSlider);
        tabbedCollectionLink.forEach(tab => {
            tab.addEventListener('click', function(e) {
                e.preventDefault();
                const contentNum = e.target.getAttribute('data-collection');
                const activeTab = document.querySelector('.tabbed-collections__link.active');
                const activeContent = document.querySelector('.tabbed-collections__tabbed-content.active');
                const tabToDisplay = document.querySelector(`.tabbed-collections__tabbed-content[data-collection="${contentNum}"]`);
                const activeSlider = tabToDisplay.querySelector('.product-grid-featured');
                activeContent.classList.remove('active');
                activeTab.classList.remove('active');
                e.target.classList.add('active');
                tabToDisplay.classList.add('active');
                activateSlider(activeSlider);
            });
        })
    }

    const mobileSliders = document.querySelectorAll('.mobile-slider');
    if(mobileSliders.length) {
        const query = '(max-width: 768px)';
        mobileSliders.forEach(elem => {
            mediaQueryActivateSlider(elem, query);
        });
    }

    document.querySelectorAll('.filter-tab_collection').forEach(collection => {
        const tabbedCollectionPill = collection.querySelectorAll('.filter-links__tab');
    
        if (tabbedCollectionPill.length) {
            // Initialize Flickity on the initially active slider within this collection
            const activeSlider = collection.querySelector('.filter-links__panel.active .collection-tab__slider');
            if (activeSlider) activateSliderTab(activeSlider);
    
            tabbedCollectionPill.forEach(tab => {
                tab.addEventListener('click', function(e) {
                    e.preventDefault();
    
                    // Get data-ref attribute from the clicked tab
                    const contentNum = e.target.getAttribute('data-ref');
                    
                    // Find the currently active tab and panel within this collection, and remove their active classes
                    const activeTab = collection.querySelector('.filter-links__tab.active');
                    const activeContent = collection.querySelector('.filter-links__panel.active');
                    
                    // Find the new panel to display based on the data-ref attribute
                    const tabToDisplay = collection.querySelector(`.filter-links__panel[data-ref="${contentNum}"]`);
                    const newActiveSlider = tabToDisplay.querySelector('.collection-tab__slider');
    
                    // Update active states for tab and panel
                    if (activeContent) activeContent.classList.remove('active');
                    if (activeTab) activeTab.classList.remove('active');
                    
                    e.target.classList.add('active');
                    tabToDisplay.classList.add('active');
    
                    // Activate Flickity on the new active slider
                    if (newActiveSlider) activateSliderTab(newActiveSlider);
                });
            });
        }
    
        // Function to activate Flickity on a given slider
        function activateSliderTab(slider) {
            if (!slider.classList.contains('flickity-initialized')) {
                new Flickity(slider, {
                    contain: true,
                    groupCells: false,
                    draggable: true,
                    wrapAround: false,
                    prevNextButtons: true,
                    pageDots: false,
                    adaptiveHeight: false
                });
                slider.classList.add('flickity-initialized');
            } else {
                Flickity.data(slider).resize();
            }
        }
    });

    // Custom modals using theme.js Modals
    const modals = document.querySelectorAll('.js-modal-trigger');
    if(modals) {
        modals.forEach(modal => {
            let m = new theme.Modals(modal.dataset.contentId);

            modal.addEventListener('click', e => {
                if (modal.dataset.sizeGuideImg) {
                    m.modal?.setAttribute('data-size-guide-img', modal.dataset.sizeGuideImg);
                }
                m.open();
            });
        });
    }

    // Graphene search autocomplete box
    const getAutocompletePos = () => {
        let graphene_autocomplete = document.querySelector('.acs_auto_popup');
        let header_sections = document.querySelectorAll('.shopify-section-group-header-group');
        let site_header_stuck = document.querySelector('.site-header--stuck');

        let gc_plp_filter = document.querySelector('.filter__Facets-wrapper');

        let header_sections_height = 0;
        
        header_sections.forEach((section) => {
            header_sections_height += section.offsetHeight;
        })
      
        if (site_header_stuck) {
            header_sections_height = site_header_stuck.offsetHeight;
       
            if (gc_plp_filter) {
                    gc_plp_filter.style.position = 'sticky';
                 gc_plp_filter.style.top = `${header_sections_height}px`;
            }
        }else{
            if (gc_plp_filter) {
                    gc_plp_filter.style.position = 'unset';
            }
        }
    
        if (graphene_autocomplete) {
            graphene_autocomplete.style.top = `${header_sections_height}px`;

            if (window.innerWidth < 768) {
                graphene_autocomplete.style.height = `calc(100vh - ${header_sections_height + 20}px)`;
            } else {
                graphene_autocomplete.style.height = `auto`;
            }
        }
    
    }
    // page load
    getAutocompletePos();

    const getBrandsDirectoryNavPos = () => {
        let brandsDirectoryNav = document.querySelector('brands-directory nav');
        if (!brandsDirectoryNav) return;

        let header_sections = document.querySelectorAll('.shopify-section-group-header-group');
        let site_header_stuck = document.querySelector('.site-header--stuck');

        let header_sections_height = 0;
        
        header_sections.forEach((section) => {
            header_sections_height += section.offsetHeight;
        })
        if (site_header_stuck) {
            header_sections_height = site_header_stuck.offsetHeight;
        }
    
        brandsDirectoryNav.style.top = `${header_sections_height}px`;
    }
    // page load
    getBrandsDirectoryNavPos();

    // update on scroll
    window.addEventListener('scroll', () => {
        getAutocompletePos();
        getBrandsDirectoryNavPos();
    })
}

document.addEventListener('DOMContentLoaded', init, false);

// START PDP ALSO AVAILABLE IN
theme.GraphQL = {

    config:  {
        storefront_token: 'b4429bb97afeaa5f14d6453dfac89989',
        request_url: theme.routes.storefrontAPI
    },

    sendRequest: function(request, request_group, output_container, temp_data) {
        if(this.config[request_group] == null) {
            this.config[request_group] = 1;
        } else {
            this.config[request_group]++;
        }

        let return_response = null;

        let settings = {
            'crossDomain': true,
            'url': this.config.request_url,
            'method': 'POST',
            'headers': {
                'X-Shopify-Storefront-Access-Token': this.config.storefront_token,
                'Content-Type': 'application/graphql',
            },
            'data': request,
            'success': function(response) {
                theme.GraphQL.config[request_group]--;
                return_response = response;
            },
            'error': function(xhr, errDesc) {
                theme.GraphQL.config[request_group]--;
                console.log(errDesc);
            }
        };
        $.ajax(settings)
            .done(function() {
                if(request_group === "also-available") {
                    theme.AlsoAvailableIn.buildOutput(return_response);
                }
                if(request_group === "also-available-plp") {
                    theme.ProductColorSwatch.buildOutput(return_response, output_container, temp_data);
                }
                if(request_group === "data-query") {
                    theme.DataQuery.buildOutput(return_response, output_container, temp_data);
                }
                if(request_group === "pdp-data-query") {
                    theme.DataQuery.buildOutput(return_response, output_container, temp_data);
                }
                theme.GraphQL.cleanUp(request_group);
            });
    },

    sendIndividualRequest: function(request, request_group, output_container, temp_data) {
        if(this.config[request_group] == null) {
            this.config[request_group] = 1;
        } else {
            this.config[request_group]++;
        }

        let return_response = null;

        let settings = {
            'crossDomain': true,
            'url': this.config.request_url,
            'method': 'POST',
            'headers': {
                'X-Shopify-Storefront-Access-Token': this.config.storefront_token,
                'Content-Type': 'application/graphql',
            },
            'data': request,
            'success': function(response) {
                theme.GraphQL.config[request_group]--;
                return_response = response;
            },
            'error': function(xhr, errDesc) {
                theme.GraphQL.config[request_group]--;
                console.log(errDesc);
            }
        };
        $.ajax(settings)
            .done(function() {
                if(request_group === "data-query") {
                    theme.DataQuery.buildOutput(return_response, output_container, temp_data);
                }
                if(request_group === "pdp-data-query") {
                    theme.PDPDataQuery.buildOutput(return_response, output_container, temp_data);
                }
                theme.GraphQL.cleanUp(request_group);
            });
    },

    cleanUp: function(request_group) {
        if(theme.GraphQL.config[request_group] < 1) {
            $('body').trigger(request_group+":loaded");
            delete this.config[request_group];
        }
    }
};

theme.AlsoAvailableIn = (function() {
    let config = {
        request_query: '',
        current_product: '',
        product_name: '',
        image_url_structure: '',
    };

    function init(container) {
        let $container = this.$container = $(container);
        config.request_query = $container.data('request-query').replaceAll('&quot;', '\"');
        config.current_product = $container.data('current-product');
        config.product_name = $container.data('product-name');
        config.image_url_structure = $container.data('image-url-structure');

        config.request_query = config.request_query.replaceAll('"', '\\\"')

        let request_query = `
        {
            products(first: 100, query: "title:`+config.request_query+`*") {
                edges {
                    node {
                        availableForSale
                        title
                        handle
                        images(first: 2) {
                            edges {
                                node {
                                    originalSrc
                                    url(transform: {maxWidth: 100})
                                }
                            }
                        }
                    }
                }
            }
        }
        `;

        try {
            theme.GraphQL.sendRequest(request_query, "also-available");
        }
        catch(err) {
            console.error("Errors in GraphQL: "+err);
        }
    }

    function buildOutput(response) {
        let output_html = '';
        let product_arr = response.data.products.edges;

        if(product_arr.length <= 1) {
            return;
        }

        this.$container.show();

        const requestQuery = this.$container.data('request-query');
        const filteredProducts = product_arr.filter(p => p.node.title.includes(requestQuery));
        const regex = /\(([^)]+)\)/;

        // Builds swatches products
        output_html = filteredProducts.map(p => {
          const matches = p.node.title.split(' - ').pop();
          return `
            <a class="product-swatch-button${ p.node.handle === config.current_product ? ' aa-swatch--current' : ''}" href="/products/${p.node.handle}"
              style="--bgColor: ${matches.toLowerCase()}; --bgImg: url(${p.node.images.edges[0].node.url});" title="${matches}">
            </a>
          `;
        }).join('');

        // Select current swatch and displays colour name
        const currentSwatch = filteredProducts.find(p => p.node.handle === config.current_product);
        if (currentSwatch) {
          let matches = regex.exec(currentSwatch.node.title);
          this.$container.find('#current-product-color').append(matches);
        }

        this.$container.find('.aa-container').append(output_html);
        document.dispatchEvent(new CustomEvent('swatchColors:loaded'));

        // Show view more button if required
        if (this.$container.find('.aa-container').height() > 100) {
            this.$container.find('.toggle-pdp-aai-view').css('display', 'inline-block');
        }
    }

    return {
        init: init,
        buildOutput: buildOutput
    };

})();

$(document).ready(function() {
    $('[data-section-type="also-available"]').each(function() {
        theme.AlsoAvailableIn.init(this);
    });
});

$(document).on('mouseenter', '.product-swatch-button', (e) => {
    let wrapper = e.target.closest('.aa-wrapper');
    let label_current = wrapper.querySelector('.current-colour');

    let title = e.currentTarget.getAttribute('title');

    if (label_current && title) {
        label_current.innerHTML = title;
    }
})

$(document).on('mouseleave', '.product-swatch-button', (e) => {
    let wrapper = e.target.closest('.aa-wrapper');
    let label_current = wrapper?.querySelector('.current-colour');

    let title = wrapper.querySelector('.product-swatch-button.aa-swatch--current')?.getAttribute('title');

    if (label_current && title) {
        label_current.innerHTML = title;
    }
})
// END PDP ALSO AVAILABLE IN

// START PRODUCT GRID ITEM COLOUR SWATCHES
theme.ProductColorSwatch = (function() {
    let config = {
        request_query: '',
        current_product: '',
        product_name: '',
        image_url_structure: '',
    };

    let swatch_html = `
    <span class="product-swatch-button product-swatch-button--colour-swatch ###swatchCurrent###"
        data-image="###productImage###"
        data-second-image="###secondProductImage###"
        data-url="###productURL###"
        data-product="###productHandle###"
        data-title="###productTitle###"
        data-id="###productID###"
        data-first-var-id="###productFirstVarID###"
        data-price="###productPrice###"
        data-price-raw="###productPriceRaw###"
        data-compare-at-price="###productComparePrice###"
        data-compare-at-price-raw="###productComparePriceRaw###"
        data-on-sale="###onSale###"
        data-sizes='###variantSizes###'
        data-label-tags='###labelTags###'
        data-discount-message='###discountMessage###'
        data-icon-label='###iconLabel###'
        title='###swatchTitle###'
        style="background-image:url(###swatchURL###);"
        >
    </span>
    `;
    function init(container) {
        let $container = this.$container = $(container);
        config.request_query = $container.data('request-query');
        config.current_product = $container.data('current-product');
        config.product_name = $container.data('product-name');
        config.image_url_structure = $container.data('image-url-structure');

        let temp_data = {
            request_query: $container.data('request-query'),
            current_product: $container.data('current-product'),
            product_name: $container.data('product-name'),
            image_url_structure: $container.data('image-url-structure'),
        };

        let request_query = `
        {
            products(first: 250, query: "title:`+temp_data.request_query+`*") {
                edges {
                    node {
                        id
                        tags
                        compareAtPriceRange {
                            minVariantPrice {
                                amount
                            }
                        }
                        priceRange {
                            minVariantPrice {
                                amount
                            }
                        }
                        variants(first: 100) {
                            edges {
                                node {
                                    availableForSale
                                    id
                                    title
                                    selectedOptions {
                                        name
                                        value
                                    }
                                }
                            }
                        }
                        onlineStoreUrl
                        availableForSale
                        title
                        handle
                        images(first: 2) {
                            edges {
                                node {
                                    originalSrc
                                    url(transform: {maxWidth: 100})
                                }
                            }
                        }
                        metafields(identifiers: [{key: "discount_message", namespace: "custom"}, {key: "icon_label", namespace: "custom"}]) {
                            value
                            key
                            reference {
                                ... on Metaobject {
                                    id
                                    publishedAt
                                    fields {
                                        key
                                        value
                                    }
                                }
                                ... on MediaImage {
                                    id
                                    image {
                                        originalSrc
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        `;

        try {
            let title_arr = temp_data.product_name.split(' - ');
            if (title_arr.length > 2) {
                theme.GraphQL.sendRequest(request_query, "also-available-plp", $container, temp_data);
            }
        }
        catch(err) {
            console.error("Errors in GraphQL: "+err);
        }
    }

    function buildOutput(response, output_container, temp_data) {
        let output_html = '';
        let product_arr = response.data.products.edges;
        if(product_arr.length <= 1) {
            return;
        }

        // Skip products that have only 'TWL' or blank as query
        if (temp_data.request_query == 'TWL' || !temp_data.request_query) {
            return;
        }

        const retrieveID = (input) => {
            return input.split("/").pop();
        }

        // Check for 'hide-aai' tag
        let hideAAI = false;
        for (let i = 0; i < product_arr.length; i++) {
            if (temp_data.product_name == product_arr[i].node.title) {
                if (product_arr[i].node.tags.includes('hide-aai')) {
                    hideAAI = true;
                }
                break;
            }
        }
        if (hideAAI) return;

        let count = 0;
        for (let i=0;i<product_arr.length;i++) {
            if (count > 4) {
                break;
            }

            // Ensure products have a matching stem component
            if (!product_arr[i].node.title.includes(temp_data.request_query)) {
                continue;
            }

            // Skip the same product
            // if (temp_data.product_name == product_arr[i].node.title) {
            //     continue;
            // }

            // Get product stem
            let product_title = product_arr[i].node.title.split(' - ').slice(0,-1).join(' - ');

            // Skip OOS products
            if (!product_arr[i].node.availableForSale) {
                continue;
            }

            // variant sizes
            let variant_arr = product_arr[i].node.variants.edges;

            let sizes_html = '';
            for (let j = 0; j<variant_arr.length; j++) {
                let has_size = false;
                let selected_options = variant_arr[j].node.selectedOptions;
                selected_options.forEach(opt => {
                    if (opt.name.toLowerCase().includes('size')) {
                        has_size = opt.value;
                    }
                })

                let temp = `
                <button class="grid-product__quick-add-var"${variant_arr[j].node.availableForSale ? '' : ' disabled'} data-id="${retrieveID(variant_arr[j].node.id)}" ${product_arr[i].node.tags.includes('ignore-gwp') ? 'data-ignore-gwp' : ''}>
                  ${has_size ?? variant_arr[j].node.title}
                </button>
                `;

                sizes_html = sizes_html += temp;
            }
            // end variant sizes

            let temp = product_title[1];
            if(temp) {
              temp = temp.split(")");
              temp = temp[0].replaceAll(' ', '-');
              temp = temp.replaceAll('/', '-');
            } else {
              temp = '';
            }
            let swatch_url = temp_data.image_url_structure.replace("---productTitle---",temp.toLowerCase());
            // let output = swatch_html.replace("###swatchURL###",swatch_url);
            let output = swatch_html.replace("###swatchURL###",product_arr[i].node.images.edges[0].node.url);
            let productURL = "/products/"+product_arr[i].node.handle;
            if(productURL) {
              output = output.replaceAll("###productURL###",productURL);
              output = output.replace("###productHandle###", product_arr[i].node.handle);
            }
            output = output.replace("###productImage###", product_arr[i].node.images.edges[0].node.originalSrc);
            if(product_arr[i].node.images.edges[1]) {
              output = output.replace("###secondProductImage###", product_arr[i].node.images.edges[1].node.originalSrc);
            } else {
              output = output.replace("###secondProductImage###", product_arr[i].node.images.edges[0].node.originalSrc);
            }

            output = output.replace("###productTitle###", product_arr[i].node.title);

            let discountMessageHTML = '';
            for (field in product_arr[i].node.metafields) {
                if (product_arr[i].node.metafields?.[field]?.key === "discount_message") {
                    if (product_arr[i].node.metafields[field].reference?.fields) {
                        discountMessageHTML = JSON.stringify(product_arr[i].node.metafields[field].reference?.fields);
                    }
                }
            }
            output = output.replace("###discountMessage###", discountMessageHTML);

            let iconLabelHTML = '';
            for (field in product_arr[i].node.metafields) {
                if (product_arr[i].node.metafields?.[field]?.key === "icon_label") {
                    iconLabelHTML = product_arr[i].node.metafields[field]?.reference?.image?.originalSrc;
                }
            }
            output = output.replace("###iconLabel###", iconLabelHTML);

            let productID = product_arr[i].node.id;
            let stringID = productID.split('/');
            stringID = stringID[stringID.length - 1];
            output = output.replace("###productID###", stringID);

            let variantID = product_arr[i].node.variants.edges[0].node.id;
            let varStringID = variantID.split('/');
            varStringID = varStringID[varStringID.length - 1];
            output = output.replace("###productFirstVarID###", varStringID);

            output = output.replace("###variantSizes###", sizes_html);

            let prodPrice = new Intl.NumberFormat('en-AU', {
                style: 'currency',
                currency: Shopify.currency.active
            }).format(product_arr[i].node.priceRange.minVariantPrice.amount);
            output = output.replace("###productPrice###", prodPrice);

            output = output.replace("###productPriceRaw###", product_arr[i].node.priceRange.minVariantPrice.amount);
            output = output.replace("###productComparePriceRaw###", product_arr[i].node.compareAtPriceRange.minVariantPrice.amount);

            let prodComparePrice = new Intl.NumberFormat('en-AU', {
              style: 'currency',
              currency: Shopify.currency.active
            }).format(product_arr[i].node.compareAtPriceRange.minVariantPrice.amount);
            output = output.replace("###productComparePrice###", prodComparePrice);

            output = output.replace("###onSale###", prodPrice < prodComparePrice);

            let tags = product_arr[i].node.tags;
            let labelTags = [];
            tags.forEach(elem => {
              if (elem.includes('_label_')) {
                labelTags.push(elem.replace('_label_', '').trim());
              }
            });
            labelTags = JSON.stringify(labelTags);
            output = output.replace("###labelTags###", labelTags);

            let splitTitle = product_arr[i].node.title.split(' (');
            let removeLastBracket = splitTitle[splitTitle.length - 1].split(')');
            let titleColour = removeLastBracket[0];
            output = output.replace('###swatchTitle###', titleColour);
            if(product_arr[i].node.handle === temp_data.current_product) {
                output = output.replace("###swatchCurrent###","aa-swatch--current aa-swatch--initial");
            } else {
                output = output.replace("###swatchCurrent###", "");
            }
            output_html += output;
            count++;
        }
        
        if (count > 1) {
            output_container.find('.aa-container').append(output_html);

            let content_wrapper = output_container[0]?.closest('.grid-product__content');
            if (content_wrapper) {
                content_wrapper.classList.add('has-colours');
            }

            output_container.show();
        }

        document.dispatchEvent(new CustomEvent('swatchColors:loaded'));
    }

    return {
        init: init,
        buildOutput: buildOutput
    };

})();

document.addEventListener('PLPProducts:built', () => {
    setTimeout(() => {
        $('[data-section-type="product-color-swatch"]').each(function() {
            this.setAttribute('data-section-type', 'product-color-swatch--full');
            theme.ProductColorSwatch.init(this);
        });
    }, 1000);
})

// START PRODUCT GRID ITEM DATA QUERY
theme.DataQuery = (function() {
    let config = {
        current_product: '',
        product_name: '',
        product_price: '',
        image_url_structure: '',
    };

    function init(container) {
        let $container = this.$container = $(container);
        config.current_product = $container.data('current-product');
        config.product_name = $container.data('product-name');
        config.product_price = $container.data('product-price');

        let temp_data = {
            current_product: $container.data('current-product'),
            product_name: $container.data('product-name'),
            product_price: $container.data('product-price'),
            element_name: $container.data('element-name'),
        };

        let individual_request_query = `
        {
            productByHandle(handle: "${temp_data.current_product}") {
                tags
                options(first: 4) {
                    name
                    values
                }
                variants(first: 100) {
                    edges {
                        node {
                            id
                            availableForSale
                            title
                            selectedOptions {
                                name
                            value
                            }
                        }
                    }
                }
                handle
                metafields(identifiers: [{key: "discount_message", namespace: "custom"}, {key: "icon_label", namespace: "custom"}]) {
                    value
                    key
                    reference {
                        ... on Metaobject {
                            id
                            fields {
                                key
                                value
                            }
                        }
                        ... on MediaImage {
                            id
                            image {
                                originalSrc
                            }
                        }
                    }
                }
            }
        }
        `;

        try {
            theme.GraphQL.sendIndividualRequest(individual_request_query, "data-query", container, temp_data);
        }
        catch(err) {
            console.error("Errors in GraphQL: "+err);
        }

    }

    function buildDiscountMessageOutput(product, container, temp_data) {
        const output_container = container.querySelector('.discount-message__wrapper');
        if (!output_container) return;

        let metafieldData = false;
        for (field in product.metafields) {
            if (product.metafields?.[field]?.key === "discount_message") {
                metafieldData = product.metafields[field].reference?.fields;
            }
        }
        if (!metafieldData) return;


        // Get metaobject data
        let discount_bg_color = '';
        let discount_text_color = '';
        let discount_amount = '';
        let discount_message = '';
        let discount_percentage = '';

        for (entry in metafieldData) {
            const {key, value} = metafieldData[entry];
            if (key == 'background_colour') {
                discount_bg_color = value;
            }
            if (key == 'text_colour') {
                discount_text_color = value;
            }
            if (key == 'discount') {
                discount_amount = value;
            }
            if (key == 'message') {
                discount_message = value;
            }
            if (key == 'percentage') {
                discount_percentage = value;
            }
        }

        if (!discount_bg_color || !discount_text_color || !discount_amount || !discount_message || !discount_percentage) return;

        const price = temp_data.product_price;
        let final_price = price;

        if (discount_percentage == "true") {
            let multiplier = 100 - discount_amount;
            final_price = (price * multiplier) / 100;
        } else {
            final_price = price - (discount_amount * 100);
        }

        let final_money = theme.Currency.formatMoney(final_price);

        let output_html = `
        <div class="grid-product__discount-message" style="background-color: ${discount_bg_color}; color: ${discount_text_color};">
            ${discount_message.replace('[PRICE]', final_money)}
        </div>
        `;
        
        output_container.innerHTML = output_html;

        let content_wrapper = output_container.closest('.grid-product__content');
        if (content_wrapper) {
            content_wrapper.classList.add('has-discount-message');
        }

        output_container.style.display = "block";
    }

    function buildQuickAdd(product, container, temp_data) {

        const getIDComponent = (string) => {
            return string.split('/').pop();
        }
        // Check quick add wrapper element exists
        const output_container = container.querySelector('.grid-product__quick-add-wrapper');
        if (!output_container) return;

        // Check for prodcut option data
        const product_options = product.options;
        if (!product_options) return;

        // check for single variant
        if (product.variants.edges.length == 1) {
            single_var_quick_add_html = `
                <div class="grid-product__quick-add">
                    <button
                        type="button"
                        class="grid-product__quick-add-var btn btn--full${product.variants.edges[0].node.availableForSale ? '' : ' quick-add-var--oos'}"
                        data-id="${getIDComponent(product.variants.edges[0].node.id)}"
                        ${product.variants.edges[0].node.availableForSale ? '' : 'disabled'}
                        ${product.tags.includes('ignore-gwp') ? 'data-ignore-gwp' : ''}
                    >
                        <span>Quick Add </span>+
                    </button>
                </div>
            `;

            output_container.innerHTML = single_var_quick_add_html;

            let content_wrapper = output_container.closest('.grid-product__content');
            if (content_wrapper) {
                content_wrapper.classList.add('has-quick-add');
            }

            output_container.style.display = "block";

            return;
        }

        // Check for 'size' option and that other options are irrelevant
        let has_size_option = false;
        let has_usable_values = true;
        product_options.forEach((option) => {
            if (option.name.toLowerCase() == 'size' || option.name.toLowerCase() == 'sizing') {
                has_size_option = true;
            } else {
                if (option.values.length > 1) {
                    has_usable_values = false;
                }
            }
        })
        if (!has_size_option || !has_usable_values) return;

        // Check for variant data
        const variantData = product.variants?.edges;
        if (!variantData) return;

        let quick_add_html = `
        <div class="grid-product__quick-add">
            <button type="button" class="grid-product__quick-add-btn h5 text-heading">
                <span>Quick Add </span>+
            </button>
            <div class="grid-product__quick-add-panel">
        `;

        variantData.forEach(varData => {
            const data = varData.node;

            quick_add_html += `
                <button type="button" class="grid-product__quick-add-var" data-id="${getIDComponent(data.id)}" ${data.availableForSale ? '' : 'disabled'} ${product.tags.includes('ignore-gwp') ? 'data-ignore-gwp' : ''}>
            `;

            for (let i = 0; i < data.selectedOptions.length; i++) {
                if (data.selectedOptions[i].name.toLowerCase() == 'size' || data.selectedOptions[i].name.toLowerCase() == 'sizing') {
                    quick_add_html += `
                        ${data.selectedOptions[i].value}
                    `;
                }
            }

            quick_add_html += `
                </button>
            `;
        })

        quick_add_html += `
            </div>
        </div>
        `;

        output_container.innerHTML = quick_add_html;

        let content_wrapper = output_container.closest('.grid-product__content');
        if (content_wrapper) {
            content_wrapper.classList.add('has-quick-add');
        }

        output_container.style.display = "block";
    }

    function buildSaleSliderQuickAdd(product, container, temp_data) {
        const getIDComponent = (string) => {
            return string.split('/').pop();
        }
        // Check quick add wrapper element exists
        const output_container = container.querySelector('.grid-product__quick-add-wrapper');
        if (!output_container) return;

        // Check for prodcut option data
        const product_options = product.options;
        if (!product_options) return;

        // check for single variant
        if (product.variants.edges.length == 1) {
            single_var_quick_add_html = `
                <div class="grid-product__quick-add">
                    <button
                        type="button"
                        class="mobile-cart-upsell-panel__quick-add-btn--single btn btn--full${product.variants.edges[0].node.availableForSale ? '' : ' quick-add-var--oos'}"
                        data-id="${getIDComponent(product.variants.edges[0].node.id)}"
                        ${product.variants.edges[0].node.availableForSale ? '' : 'disabled'}
                        ${product.tags.includes('ignore-gwp') ? 'data-ignore-gwp' : ''}
                    >
                        Add To Cart
                    </button>
                </div>
            `;

            output_container.innerHTML = single_var_quick_add_html;

            let content_wrapper = output_container.closest('.grid-product__content');
            if (content_wrapper) {
                content_wrapper.classList.add('has-quick-add');
            }

            output_container.style.display = "block";

            return;
        }

        // Check for 'size' option and that other options are irrelevant
        let has_size_option = false;
        let has_usable_values = true;
        product_options.forEach((option) => {
            if (option.name.toLowerCase() == 'size' || option.name.toLowerCase() == 'sizing') {
                has_size_option = true;
            } else {
                if (option.values.length > 1) {
                    has_usable_values = false;
                }
            }
        })
        if (!has_size_option || !has_usable_values) return;

        // Check for variant data
        const variantData = product.variants?.edges;
        if (!variantData) return;

        let options_list = '';
        variantData.forEach(varData => {
            const data = varData.node;

            options_list += `
                <option value="${getIDComponent(data.id)}" ${data.availableForSale ? '' : 'disabled'} ${product.tags.includes('ignore-gwp') ? 'data-ignore-gwp' : ''}>
            `;

            for (let i = 0; i < data.selectedOptions.length; i++) {
                if (data.selectedOptions[i].name.toLowerCase() == 'size' || data.selectedOptions[i].name.toLowerCase() == 'sizing') {
                    options_list += `
                        ${data.selectedOptions[i].value}
                    `;
                }
            }

            options_list += `
                </option>
            `;
        })


        
        let quick_add_html = `
        <div class="grid-product__quick-add">
            <div>
                <select>
                    <option selected hidden disabled value="">Select Size</option>
                    ${options_list}
                </select>
            </div>
            <button type="button" class="btn btn--full mobile-cart-upsell-panel__quick-add-btn h5 text-heading">
                Add To Cart
            </button>
        </div>
        `;

        output_container.innerHTML = quick_add_html;

        let content_wrapper = output_container.closest('.grid-product__content');
        if (content_wrapper) {
            content_wrapper.classList.add('has-quick-add');
        }

        output_container.style.display = "block";
    }

    function buildIconLabel(product, container, temp_data) {
        let imgSrc = false;
        for (field in product.metafields) {
            if (product.metafields?.[field]?.key === 'icon_label') {
                imgSrc = product.metafields[field]?.reference?.image?.originalSrc;
            }
        }
        if (!imgSrc) return;

        let content_wrapper = container.querySelector('.grid-product__content');
        if (!content_wrapper) return;

        // Check for existing label
        let current_tag = content_wrapper.querySelector('.grid-product__tag:not(.grid-product__tag--more-colours)');
        if (current_tag) {
            if (current_tag.classList.contains('grid-product__tag--custom')) {
                console.log('has custom tag, exiting...');
                return;
            } else {
                current_tag.innerHTML = `
                    <img src="${imgSrc}" alt="icon label" />
                `;
            }
        } else {
            let product_tag = document.createElement('div');
            product_tag.classList.add('grid-product__tag', 'grid-product__tag--icon');
            product_tag.innerHTML = `<img src="${imgSrc}" alt="icon label" />`;

            content_wrapper.appendChild(product_tag);
        }
        content_wrapper.classList.add('has-icon-label');
    }

    function buildOutput(response, container, temp_data) {
        const product = response?.data?.productByHandle;
        if (!product) return;

        if (product.handle != temp_data.current_product) {
            return;
        }

        buildDiscountMessageOutput(product, container, temp_data);

        if (!product.tags.includes('hide-quick-add')) {
            if (temp_data.element_name == "mobile_cart_upsell") {
                buildSaleSliderQuickAdd(product, container, temp_data);
            } else {
                buildQuickAdd(product, container, temp_data);
            }
        }

        buildIconLabel(product, container, temp_data);

        document.dispatchEvent(new CustomEvent('dataQuery:loaded'));
    }

    return {
        init: init,
        buildOutput: buildOutput
    };

})();

document.addEventListener('PLPProducts:built', () => {
    setTimeout(() => {
        $('[data-item-query="product-query"]').each(function() {
            this.setAttribute('data-item-query', 'product-query--full');
            theme.DataQuery.init(this);
        });
    }, 1000);
})

document.addEventListener('drawerOpen.CartDrawer', () => {
    setTimeout(() => {
        $('[data-item-query="cart-drawer-product-query"]').each(function() {
            this.setAttribute('data-item-query', 'cart-drawer-product-query--full');
            theme.DataQuery.init(this);
        });
    }, 1000);
})
// END PRODUCT GRID ITEM DATA QUERY

// START PDP CTL DATA QUERY
theme.PDPDataQuery = (function() {
    let config = {
        current_product: '',
        product_name: '',
    };

    function init(container) {
        let $container = this.$container = $(container);
        config.current_product = $container.data('current-product');
        config.product_name = $container.data('product-name');

        let temp_data = {
            current_product: $container.data('current-product'),
            product_name: $container.data('product-name'),
        };

        let individual_request_query = `
        {
            productByHandle(handle: "${temp_data.current_product}") {
                tags
                onlineStoreUrl
                options(first: 4) {
                    name
                    values
                }
                variants(first: 100) {
                    edges {
                        node {
                            id
                            availableForSale
                            title
                            selectedOptions {
                                name
                            value
                            }
                        }
                    }
                }
                handle
            }
        }
        `;

        try {
            theme.GraphQL.sendIndividualRequest(individual_request_query, "pdp-data-query", container, temp_data);
        }
        catch(err) {
            console.error("Errors in GraphQL: "+err);
        }

    }

    function buildQuickAdd(product, container, temp_data) {
        const quick_add_wrapper = container.querySelector('.grid-product__ctl-quick-add');

        // check if element exists
        if (!quick_add_wrapper) return;

        let use_product_link = false;

        // Check for prodcut option data
        const product_options = product.options;
        if (!product_options) {
            use_product_link = true;
        };

        // Check for 'size' option and that other options are irrelevant
        let has_size_option = false;
        let has_usable_values = true;
        product_options.forEach((option) => {
            if (option.name.toLowerCase() == 'size' || option.name.toLowerCase() == 'sizing') {
                has_size_option = true;
            } else {
                if (option.values.length > 1) {
                    has_usable_values = false;
                }
            }
        })
        if (!has_size_option || !has_usable_values) {
            use_product_link = true;
        };

        // Check for variant data
        const variantData = product.variants?.edges;
        if (!variantData) {
            use_product_link = true;
        };

        if (use_product_link) {
            // add link btn
            let btn_html = `
            <a class="btn" href="${product.onlineStoreUrl ? product.onlineStoreUrl : `/products/${temp_data.current_product}`}">View Product</a>
            `;

            quick_add_wrapper.innerHTML = btn_html;

            return;
        }

        let final_html = '';

        const getIDComponent = (string) => {
            return string.split('/').pop();
        }

        let select_html = `
        <select>
            <option selected disabled hidden value="">Select Size</option>
        `;
        variantData.forEach(varData => {
            const data = varData.node;

            select_html += `
                <option value="${getIDComponent(data.id)}" ${data.availableForSale ? '' : 'disabled'}>
            `;
            for (let i = 0; i < data.selectedOptions.length; i++) {
                if (data.selectedOptions[i].name.toLowerCase() == 'size' || data.selectedOptions[i].name.toLowerCase() == 'sizing') {
                    select_html += `
                        ${data.selectedOptions[i].value}
                    `;
                }
            }
            select_html += `
                </option>
            `;
        })
        select_html += `
        </select>
        `;

        let btn_html = `
        <button class="btn pdp-ctl__atc-btn btn--black" ${product.tags.includes('ignore-gwp') ? 'data-ignore-gwp' : ''}>Add To Cart</button>
        `;

        final_html += select_html;
        final_html += btn_html;

        quick_add_wrapper.innerHTML = final_html;

        return;
    }

    function buildOutput(response, container, temp_data) {
        const product = response?.data?.productByHandle;
        if (!product) return;

        if (product.handle != temp_data.current_product) {
            return;
        }

        buildQuickAdd(product, container, temp_data);

        document.dispatchEvent(new CustomEvent('PDP_dataQuery:loaded'));
    }

    return {
        init: init,
        buildOutput: buildOutput
    };

})();

document.addEventListener('PDP-CTL:built', () => {
    setTimeout(() => {
        $('[data-item-query="pdp-product-query"]').each(function() {
            this.setAttribute('data-item-query', 'pdp-product-query--full');
            theme.PDPDataQuery.init(this);
        });
    }, 1500);
})
// END PDP CTL DATA QUERY

// START PDP CTL QUICK ADD
$(document).on('click', '.pdp-ctl__atc-btn', (e) => {
    let atc_btn = e.currentTarget;
    let parent = atc_btn.closest('.grid-product__ctl-quick-add');

    let select = parent.querySelector('select');
    let var_id = select.options[select.selectedIndex].value;

    if (!var_id || var_id == '') return;

    let properties = {};
    if (parent.hasAttribute('data-ignore-gwp')) {
        properties["_ignore-gwp"] = true;
    }
    if (atc_btn.hasAttribute('data-ignore-gwp')) {
        properties["_ignore-gwp"] = true;
    }

    let data = {
        "id": var_id,
        "quantity": 1,
        "properties": properties
    }
      
    jQuery.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: data,
        dataType: 'json',
        success: function(res) { 
            document.dispatchEvent(new CustomEvent('cart:build'));
            document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
                detail: {
                    cart: data
                }
            }));

            try {
                $g.track({
                    scope: "basket",
                    action: "add",
                    data: { product_id: res.product_id , quantity: 1 },
                    successs:function(response){
                        console.log("adding",response)
                    }
                });
            } catch (err) {
                console.log({err})
            }
        }
    });
})
// END PDP CTL QUICK ADD


// Update Grid Item On Swatch Click
$(document).on('click', '.product-swatch-button--colour-swatch', function(e) {
    e.preventDefault;

    let url = this.getAttribute('data-url');
    let image = this.getAttribute('data-image');
    let hoverImage = this.getAttribute('data-second-image');
    let title = this.getAttribute('data-title');
    let ID = this.getAttribute('data-id');
    let firstVarID = this.getAttribute('data-first-var-id');
    let price = this.getAttribute('data-price');
    let compareAtPrice = this.getAttribute('data-compare-at-price');
    let priceRaw = this.getAttribute('data-price-raw');
    let compareAtPriceRaw = this.getAttribute('data-compare-at-price-raw');
    let onSale = this.getAttribute('data-on-sale');
    let sizes = this.getAttribute('data-sizes');
    let labelTags = this.getAttribute('data-label-tags');
    let discountMessage = this.getAttribute('data-discount-message');
    let iconLabel = this.getAttribute('data-icon-label');
    let container = this.closest('.grid-product');

    // change active swatch
    container.querySelector('.aa-swatch--current')?.classList.remove('aa-swatch--current');
    this.classList.add('aa-swatch--current');

    // // update label
    labelTags = JSON.parse(labelTags);
    // remove all current labels
    let defaultContentDiv = container.querySelector('.grid-product__content');
    let defaultLabelDivs = defaultContentDiv.querySelectorAll('.grid-product__tag:not(.grid-product__tag--more-colours)');
    if (defaultLabelDivs) {
      defaultLabelDivs.forEach(label => defaultContentDiv.removeChild(label));
    }
    // create new label
    let newLabel;
    if (labelTags.length > 0) {
      newLabel = document.createElement('span');
      newLabel.classList.add('grid-product__tag', 'grid-product__tag--custom');
      newLabel.innerHTML = labelTags[0];
    } else {
        if (iconLabel && iconLabel != '') {
            newLabel = document.createElement('span');
            newLabel.classList.add('grid-product__tag', 'grid-product__tag--icon');
            newLabel.innerHTML = `<img src="${iconLabel} alt="icon" />`;
        }
    }
    // add new label
    if(newLabel && defaultContentDiv) {
      defaultContentDiv.appendChild(newLabel);
    }

    // savings label
    if (compareAtPriceRaw && theme.settings.productSaveAmount) {
        let curPrice = parseFloat(priceRaw);
        let compPrice = parseFloat(compareAtPriceRaw);
        let diff = compPrice - curPrice;

        let currSavingsLabel = defaultContentDiv.querySelector('.grid-product__tag--savings');

        if (diff > 0) {
            let savings;
            if (theme.settings.productSaveType == 'dollar') {
                savings = new Intl.NumberFormat('en-AU', {
                    style: 'currency',
                    currency: Shopify.currency.active
                }).format(diff);
            } else {
                savings = `${parseInt(diff / compPrice * 100)}%`;
            }

            if (currSavingsLabel) {
                // update exisiting label
                currSavingsLabel.innerHTML = `Save ${savings}`;
            } else {
                // create savings label
                let savingsLabel = document.createElement('span');
                savingsLabel.classList.add('grid-product__tag', 'grid-product__tag--savings')
                savingsLabel.innerHTML = `Save ${savings}`;

                if(savingsLabel && defaultContentDiv) {
                    defaultContentDiv.appendChild(savingsLabel);
                }
            }
        } else {
            if (currSavingsLabel) {
                currSavingsLabel.innerHTML = '';
            }
        }
    }

    // update discount message
    const output_container = container.querySelector('.discount-message__wrapper');
    const metafieldData = discountMessage && discountMessage != '' ? JSON.parse(discountMessage) : false;

    if (output_container && metafieldData) {
        // Get metaobject data
        let discount_bg_color = '';
        let discount_text_color = '';
        let discount_amount = '';
        let discount_message = '';
        let discount_percentage = '';

        for (entry in metafieldData) {
            const {key, value} = metafieldData[entry];
            if (key == 'background_colour') {
                discount_bg_color = value;
            }
            if (key == 'text_colour') {
                discount_text_color = value;
            }
            if (key == 'discount') {
                discount_amount = value;
            }
            if (key == 'message') {
                discount_message = value;
            }
            if (key == 'percentage') {
                discount_percentage = value;
            }
        }

        if (discount_bg_color && discount_text_color && discount_amount && discount_message && discount_percentage) {
            const numberPattern = /\d+/g;
            let priceCents = price.match(numberPattern).join('')
            
            let final_price = priceCents;
    
            if (discount_percentage == "true") {
                let multiplier = 100 - discount_amount;
                final_price = (priceCents * multiplier) / 100;
            } else {
                final_price = priceCents - (discount_amount * 100);
            }
    
            let final_money = theme.Currency.formatMoney(final_price);
    
            let output_html = `
            <div class="grid-product__discount-message" style="background-color: ${discount_bg_color}; color: ${discount_text_color};">
                ${discount_message.replace('[PRICE]', final_money)}
            </div>
            `;
    
            output_container.innerHTML = output_html;
    
            let content_wrapper = output_container.closest('.grid-product__content');
            if (content_wrapper) {
                content_wrapper.classList.add('has-discount-message');
            }
    
            output_container.style.display = "block";
        };
    } else if (output_container) {
        output_container.innerHTML = '';
        output_container.style.display = "none";
    }
    
    // update image
    let currentImage = container.querySelector('.grid-product__image');
    if (!currentImage) {
        // Check Graphene content
        currentImage = container.querySelector('.gc_product_item_image');
    }
    if (currentImage) {
        container.querySelector('.image-wrap').innerHTML = '';
    }
    let currentVideo = container.querySelector('.image-wrap video');
    if (currentVideo) {
      currentVideo.closest('.image-wrap').innerHTML = '';
    }
    container.querySelector('.image-wrap').style.backgroundImage = `url('${image}')`;
    container.querySelector('.image-wrap').style.backgroundSize = "cover";

    // Update hover image
    let hoverCurrentImage = container.querySelector('.grid-product__secondary-image img');
    if(hoverCurrentImage) {
      container.querySelector('.grid-product__secondary-image').innerHTML = '';
    }
    let hoverCurrentVideo = container.querySelector('.grid-product__secondary-image video');
    if (hoverCurrentVideo) {
      hoverCurrentVideo.closest('.grid-product__secondary-image').innerHTML = '';
    }

    let hoverImageContainer = container.querySelector('.grid-product__secondary-image');
    if(hoverImageContainer) {    
      container.querySelector('.grid-product__secondary-image').style.backgroundImage = `url('${hoverImage}')`;
      container.querySelector('.grid-product__secondary-image').style.backgroundSize = "cover";
    }

    // update links
    let link_elems = container.querySelectorAll('.grid-product__link');
    link_elems.forEach(link => {
        link.setAttribute('href', url);
    })

    // update title
    let titleContainer = container.querySelector('.grid-product__title');
    let titleHTML = `${title}`;
    titleContainer.innerHTML = titleHTML;

    // update price
    container.querySelector('.grid-product__price .money').innerHTML = price;
    container.querySelector('.grid-product__price .money').setAttribute('data-currency-aud', price);

    // check if sale, apply styles
    if (compareAtPrice && compareAtPrice != '$0.00' && compareAtPrice != price) {
        // get price elem
        let mainPriceElem = container.querySelector('.grid-product__price > span:not(.grid-product__price--original)');
        // add red
        mainPriceElem.classList.add('text-red')
    } else {
        // get price elem
        let mainPriceElem = container.querySelector('.grid-product__price > span:not(.grid-product__price--original)');
        // add red
        mainPriceElem.classList.remove('text-red')
    }

    // update compare at price
    // remove current compare at price
    let priceDiv = container.querySelector('.grid-product__price');
    let priceOriginal = container.querySelector('.grid-product__price--original');
    if (priceDiv && priceOriginal) {
      priceDiv.removeChild(priceOriginal);
    }
    // add new compare at price
    if (compareAtPrice && compareAtPrice != '$0.00' && compareAtPrice != price) {
        let compareAtSpan = document.createElement('span');
        compareAtSpan.classList.add('grid-product__price--original');
        compareAtSpan.innerHTML = `<span class="money" data-currency-aud="${compareAtPrice}">${compareAtPrice}</span>`;
        priceDiv.appendChild(compareAtSpan);

        // add sale label if applicable
        let newLabel;
        if (labelTags.length === 0) {
            newLabel = document.createElement('span');
            newLabel.classList.add('grid-product__tag', 'grid-product__tag--sale');
            newLabel.innerHTML = "SALE";
        }
        if (newLabel && defaultContentDiv) {
            defaultContentDiv.appendChild(newLabel);
        }
    }

    // // update quick add
    let quickAddPanel = container.querySelector('.grid-product__quick-add-panel');
    if (quickAddPanel) {
        quickAddPanel.innerHTML = sizes;
    }
})
// END PRODUCT GRID ITEM COLOUR SWATCHES

// START QUICK ADD
$(document).on('click', '.grid-product__quick-add-btn', (e) => {
    let btn = e.currentTarget;
    let parent = btn.closest('.grid-product__quick-add');
    parent.classList.toggle('active');
})

$(document).on('click', '.grid-product__quick-add-var', (e) => {
    let btn = e.currentTarget;
    if (btn.hasAttribute("disabled")) return;

    let varID = btn.getAttribute('data-id');
    if (!varID) return;

    let properties = {};
    if (btn.hasAttribute('data-ignore-gwp')) {
        properties["_ignore-gwp"] = true;
    }

    let data = {
        "id": varID,
        "quantity": 1,
        "properties": properties
    }
      
    jQuery.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: data,
        dataType: 'json',
        success: function(res) { 
            document.dispatchEvent(new CustomEvent('cart:build'));

            document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
                detail: {
                    cart: data
                }
            }));

            try {
                $g.track({
                    scope: "basket",
                    action: "add",
                    data: { product_id: res.product_id , quantity: 1 },
                    successs:function(response){
                        console.log("adding",response)
                    }
                });
            } catch (err) {
                console.log({err})
            }
        }
    });
})
// END QUICK ADD
  
// START TEMPLATE BUNDLES
const removeBundleFromCart = async (e) => {
    const self = e.currentTarget;
    const variants = self.dataset.bundleKeys;
    const variantsArr = Array.from(variants.split(','));

    let obj = variantsArr.reduce((o, key) => ({ ...o, [key]: 0}), {});

    try {
        self.classList.add('btn--loading');

        const res = await fetch('/cart/update.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                updates: obj
            })
        });
        const data = await res.json();

        if (res.ok) {
            document.dispatchEvent(new CustomEvent('cart:build', {
                detail: {
                    cart: data
                }
            }));
        }
    }
    catch (err) {
        console.log(err);
        self.classList.remove('btn--loading');
    }
    finally {
        self.classList.remove('btn--loading');
    }
}

$(document).on('click', '.js-remove-bundle', (e) => {
    removeBundleFromCart(e);
})
// END TEMPLATE BUNDLES

// START PDP AAI TOGGLE
$(document).on('click', '.toggle-pdp-aai-view', (e) => {
    const button = e.currentTarget;
    const parent = button.closest('.aa-wrapper');
    const panel = parent?.querySelector('.aa-container');

    if (!parent || !panel) return;

    if (button.getAttribute('data-active') == 'false') {
        panel.classList.add('expanded');
        button.setAttribute('data-active', 'true');
        button.innerHTML = 'Show Less';
    } else {
        panel.classList.remove('expanded');
        button.setAttribute('data-active', 'false');
        button.innerHTML = 'Show More';
    }
    
})
// END PDP AAI TOGGLE

window.addEventListener('DOMContentLoaded', () => {
    $(document).on('click', '.cart-upsell-slider__toggle', (e) => {
        const btn = e.currentTarget;
        const parent = btn.closest('.cart-upsell-slider');
        let slider = parent.querySelector('.cart-upsell-slider__slider');
        if (!slider) {
            slider = parent.querySelector('.cart-upsell-slider__graphene-wrapper');
        }

        if (!parent || !slider) return;

        let isActive = parent.classList.contains('active');

        if (isActive) {
            parent.classList.remove('active');
        } else {
            parent.classList.add('active');
        }
    })
})

// Filter Links
window.addEventListener('DOMContentLoaded', () => {
    $(document).on('click', '.filter-links__tab', (e) => {
        const btn = e.currentTarget;
        if (btn.classList.contains('active')) return;

        const parent = btn.closest('.filter-links__block');

        // update tab
        const tab_wrapper = parent.querySelector('.filter-links__tabs');
        const tab_btns = tab_wrapper.querySelectorAll('.filter-links__tab');

        tab_btns.forEach(tab_btn => {
            tab_btn.classList.remove('active');
        })

        btn.classList.add('active');

        const ref_id = btn.getAttribute('data-ref');

        // update panel
        const panel_wrapper = parent.querySelector('.filter-links__panels');
        const panels = panel_wrapper.querySelectorAll('.filter-links__panel');

        panels.forEach(panel => {
            panel.classList.remove('active');
        })

        panels.forEach(panel => {
            if (panel.getAttribute('data-ref') == ref_id) {
                panel.classList.add('active');
            }
        })
    })
})

document.addEventListener('DOMContentLoaded', function() {
    const checkMinimumPurchase = () => {
        fetch('/cart.js')
            .then(response => response.json())
            .then(cart => {
                let isEmptyCart = cart.items.length === 0;
                const checkoutMessageElement = document.querySelector('.checkout-message__error');

                if (isEmptyCart) {
                    document.querySelector('.cart__checkout').disabled = true; // Disable checkout for empty cart
                    return;
                }

                let total = 0;
                let hasLiveFitNutrition = false; // Renamed flag

                cart.items.forEach(item => {
                    // Check if the product vendor is "Live Fit Nutrition"
                    if (item.vendor === "Live Fit Nutrition") {
                        total += item.quantity * item.price; // Total in cents
                        hasLiveFitNutrition = true; // Set flag if product vendor matches
                    }
                });

                const checkoutButton = document.querySelector('.cart__checkout');

                if (hasLiveFitNutrition) {
                    // Disable checkout if total is less than $65 (6500 cents)
                    if (total < 6500) {
                        checkoutButton.disabled = true;
                        checkoutMessageElement.textContent = 'A minimum order value of $65 is required for Live Fit Nutrition Meals.';
                    } else {
                        checkoutButton.disabled = false; // Enable if total is valid
                        checkoutMessageElement.textContent = ''
                    }
                } else {
                    // Enable checkout if there are no products from Live Fit Nutrition
                    checkoutButton.disabled = false;
                    checkoutMessageElement.textContent = ''
                }
            })
            .catch(error => console.error('Error fetching cart:', error));
    };

    // Run the check when checkout button is clicked
    const checkoutButton = document.querySelector('.cart__checkout');
    if(checkoutButton) {
        checkoutButton.addEventListener('click', function(e) {
            // Only call checkMinimumPurchase without preventDefault
            checkMinimumPurchase();
        });
    }
    // Optional: Re-run check on cart updates
    document.addEventListener('cart:updated', checkMinimumPurchase);

    if($('.template-product').length){
        // Sticky cart
      $(window).on('load resize ready click scroll',function() {
        var stickyCartHeight = $('.sticky-atc').outerHeight();
        var OTcartBTN = document.querySelector('.add-to-cart');
        var distanceToTop = OTcartBTN && OTcartBTN.getBoundingClientRect().top;

        if (distanceToTop === null) return;

       if (distanceToTop < 0){
         $('body').addClass('sticky-bottom-cart').css('padding-bottom', stickyCartHeight);
         $('.sticky-atc').css('bottom', 0);
         $('.sticky-atc_variant-btn-mobile').addClass('sticky-atc_variant-btn-mobile-active');
       }else{
         $('body').removeClass('sticky-bottom-cart').css('padding-bottom', 0);
         $('.sticky-atc').css('bottom', -(stickyCartHeight+50));
         $('.sticky-atc_variant-btn-mobile').removeClass('sticky-atc_variant-btn-mobile-active');
       }

      });

       var stickyVariantInputItem = $('.sticky-atc_variant-input-item');
       var stickyAddToCartButton = $('.btn-sticky-cart');
       var stickyVarWrapper = $('.sticky-atc_variant-wrapper');

        document.addEventListener('variant:change', function(evt) {
          var currentVariantID = evt.detail.variant.id;
          stickyAddToCartButton.attr('data-sticky-variant', currentVariantID);

          stickyVariantInputItem.each(function() {
            var variantID = $(this).attr('data-sticky-variant-item');
            $(this).prop('checked', currentVariantID == variantID);
          });
        });

        stickyVariantInputItem.on('click', function() {
          if ($(this).is(':checked')) {
              var stickyVar = $(this).attr('data-sticky-variant-item');
              var selectedVariantValue = $(this).val();

              $('.variant-input[data-value="' + selectedVariantValue + '"] input[type="radio"]').trigger('click');

              stickyAddToCartButton.attr('data-sticky-variant', stickyVar);

              if ($(this).hasClass('disabled')) {
                stickyAddToCartButton.text('Sold Out').prop('disabled', true);
              } else {
                stickyAddToCartButton.text('Add to bag').prop('disabled', false);
              }
          }
        });


       $('body').on('click', '.btn-sticky-cart[data-sticky-variant]', function(e) {
         e.preventDefault();
         addItem($(this).attr('data-sticky-variant'));
       });

       $('.btn-sticky-cart-mobile').on('click', function() {
           $(this).fadeOut(100);
           $('body').addClass('js-drawer-open');
           stickyVarWrapper.addClass('sticky-atc_variant-wrapper-active');
       })

       $(window).on('resize load', function() {
           if ($(window).width() < 769){
             stickyVarWrapper.removeClass('sticky-atc_variant-wrapper-active');

               $('body').on('click', '.sticky-atc_variant-input-item', function(e) {
                   e.preventDefault();
                   addItem($(this).attr('data-sticky-variant-item'));
               });

               $(window).mouseup(function(e) {
                   if (!stickyVarWrapper.is(e.target) && stickyVarWrapper.has(e.target).length === 0) {
                       $('body').removeClass('js-drawer-open');
                       stickyVarWrapper.removeClass('sticky-atc_variant-wrapper-active');
                       $('.btn-sticky-cart-mobile').delay(300).fadeIn().one();
                   }
               });
           } else {
             setTimeout(function () {
             $('.sticky-atc_variant-column.sticky-atc_variant-list').fadeIn().one();
             },1000);

           }
       });
    }
});

function addItem(variantID) {
    fetch('/cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            quantity: 1,
            id: variantID
        }),
    })
    .then((response) => {
        if (response.ok) {
            document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
        }
    })
    .catch((error) => console.error(error));
}

$('body').on('click', '.js-show-bundle-contents', function(e) {
    const parent = e.target.closest('.cart-bundle-contents');
    const bundleContents = parent.querySelector('.cart-bundle-contents--inner');
    bundleContents.classList.toggle('hide');
    e.target.classList.toggle('active');
});

$('.filter-links__tab').on('click', function () {
    if (!$(this).data('slick-initialized')) {
        $('.nosto-carousel').slick('setPosition');

        setTimeout(function () {
            $('.nosto-carousel').slick('setPosition');
        }, 1000);

        $(this).data('slick-initialized', true);
    }
});

// Reset initialization flag when switching tabs
$('.filter-links__tab').on('click', function () {
    $('.filter-links__tab').data('slick-initialized', false);
});

    // Search input focus functionality
function initSearchFocus() {
    const mainHeader = document.querySelector('[data-section-type="header"]');
    const searchInputs = document.querySelectorAll(
        ".drawer--nav .search-bar input, .mobile-header-search .search-bar input"
    );

    if (mainHeader && searchInputs.length > 0) {
        searchInputs.forEach((input) => {
            // Remove existing listeners to avoid duplicates
            input.removeEventListener("focus", handleSearchFocus);
            input.removeEventListener("blur", handleSearchBlur);

            // Add new listeners
            input.addEventListener("focus", handleSearchFocus);
            input.addEventListener("blur", handleSearchBlur);
        });
        return true; // Successfully initialized
    }
    return false; // Elements not found yet
}

function handleSearchFocus() {
    const mainHeader = document.querySelector('[data-section-type="header"]');
    if (mainHeader) {
        mainHeader.classList.add("main-menu-open");
    }
}

function handleSearchBlur() {
    const mainHeader = document.querySelector('[data-section-type="header"]');
    if (mainHeader) {
        mainHeader.classList.remove("main-menu-open");
    }
}

// Try to initialize immediately
document.addEventListener("DOMContentLoaded", function () {
    // Try multiple times with increasing delays
    let attempts = 0;
    const maxAttempts = 10;

    function tryInit() {
        if (initSearchFocus()) {
            console.log("Search focus functionality initialized successfully");
        } else if (attempts < maxAttempts) {
            attempts++;
            setTimeout(tryInit, 200 * attempts); // Increasing delay: 200ms, 400ms, 600ms, etc.
        } else {
            console.log(
                "Search focus functionality: elements not found after maximum attempts"
            );
        }
    }

    tryInit();
});

// Also try to initialize when the page is fully loaded
window.addEventListener("load", function () {
    setTimeout(initSearchFocus, 100);
});